export default "__VITE_ASSET__CRgxftnP__"